
$(".shoppingcart").on('click', function(e) {
  e.preventDefault();
  $('.menu-drawer-container').removeClass('menu-opening').removeAttr('open');
  $('.header__search details').removeAttr('open');
  $('body').removeClass('overflow-hidden-tablet overflow-hidden-mobile');
  $("body").toggleClass("CartOpen");
  $("body").css("overflow", "");
  setTimeout(function() {
    $('.block-cart-header h2 a.d_pargraph_7').focus()
  }, 2000);
});

$(".cart-close").on('click', function(e) {
  e.preventDefault();
  $('.menu-drawer-container').removeClass('menu-opening').removeAttr('open');
  $('.header__search details').removeAttr('open');
  $('body').removeClass('overflow-hidden-tablet overflow-hidden-mobile');
  $("body").toggleClass("CartOpen");
  
  $("body").css("overflow", "");
});

$(document).mouseup(function(e){
  var popup = $(".cart-side-panel, .you_may_also_like_div");
  if(!$('#cart.shopping-cart').is(e.target) && !popup.is(e.target) && popup.has(e.target).length == 0){
    if ($("body").hasClass("CartOpen")){
      $(".cart-close").trigger("click");
      $("body").css("overflow", "");
    }
  }
});
$(".close_subscribe").on('click', function(e) {
  $('.subscribe_form_cart_drawer').hide();
});

$('.you_also_like_ul').slick({
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1100,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 952,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});
$(".collapsible-trigger").on('click', function(e) {
  $(this).parent().siblings().removeClass("is-open").find("ul.filter-racks-item").slideUp();
  $(this).parent().toggleClass("is-open").find("ul.filter-racks-item").slideToggle();
});
$(".collapsible-trigger_sub").on('click', function(e) {
  $(this).parent(".sub_listed_filter").toggleClass("sub_is-open").find(".submenu_listing_ul").slideToggle();
});
$(".show_hide_filter_div button").on('click', function(e) {
  $("body").toggleClass("filter_sidebar_opened");
});
$(".active_filter_tags a").on('click', function(e) {
  e.preventDefault();
  $(this).parent().hide();
});
$(".js-no-transition").on('click', function(e) {

  $(this).parent().toggleClass("tag-active");
  var text_of_currant = $(this).text(); 
  $(".active_filter_tags").append("<li><span>"+text_of_currant+"</span></li>");
});


$(".filter-close").on('click', function(e) {
  $("body").removeClass("filter_sidebar_opened");
});
$(window).resize(function(){
  if($(window).width() < 750){
    $("body").removeClass("filter_sidebar_opened");
  } 
})
$(document).ready(function(){
  if($(window).width() > 749){
    $("body").addClass("filter_sidebar_opened");
  } 
  
  var details = JSON.parse(localStorage.getItem('col-img'));
  if(details){
    var img_src = details[0];
    var details_title= details[1];
    var details_url= details[2];
    var show_fetured_image = details[3];
    $('.currant__pro_fetured_img_megamenu img ').attr('src', img_src);
    $('.currant__pro_fetured_img_megamenu h5 ').text(details_title);
    $('.currant__pro_fetured_img_megamenu a ').attr('href',details_url);
    $('.currant__pro_fetured_img_megamenu').addClass(show_fetured_image);
  }
  /*------swatch currant-------*/
  var radioValue = $(".product-form__input--color .variant_values input:checked").val();
  $(".dropdown_menu_swatch .dropdown_swatch_button").text(radioValue);
});
$('.list-menu li:not(.megamenu_enable)').click(function(){
  localStorage.removeItem('col-img');
  $('.currant__pro_fetured_img_megamenu figure').hide();
})
$('.menu_blocks ul li').click(function(){
  const value_of_fetured_img = new Array($(this).closest('.mega_menu_link_inside_row').data('img'), $(this).closest('.mega_menu_link_inside_row').data('title'), $(this).closest('.mega_menu_link_inside_row').data('url'), "show_fetured_image")
  var x = $(this).closest('.mega_menu_link_inside_row').data('img')
  if (localStorage.getItem("col-img") === null) {
    var collection_img = '';
    localStorage.setItem("col-img", JSON.stringify(value_of_fetured_img));

  }else{
    localStorage.setItem("col-img", JSON.stringify(value_of_fetured_img));
  }
});


if($(window).width() <= 576){
  $(".accordian_title").on('click', function(e) {
    $(this).siblings().slideToggle();
    $(this).parent().toggleClass("mobile_nav_opened");
  });
}

$(".accordian_row .accordian_title_ a").on('click', function(e) {
  $(this).parents('.accordian_title_').siblings().slideToggle();
  $(this).parents('.accordian_listing').siblings().find('.accordian_description_').slideUp();
  $(this).parents(".accordian_listing").siblings().removeClass("accordian_is_open");
  $(this).parents('.accordian_listing').toggleClass("accordian_is_open");
});
$(".local_Pickup_grid .button").on('click', function(e) {
  $(this).parents(".local_Pickup_grid").addClass("open__pickup_form");
});
$(".close_button_this").on('click', function(e) {
  $(this).parents(".local_Pickup_grid").removeClass("open__pickup_form");
});



/*------------Product Images-------------*/

$('.product_images__ul_slide_5').slick({
  infinite : true,
  slidesToShow : 4,
  slidesToScroll : 1,
  focusOnSelect : true,
  adaptiveHeight : true,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1
      }
    }
  ]
});

if($(".product_images__ul li").length <= 3){
  $('.product_images__ul').removeClass('product_images__ul_slide_3_new_pdp').addClass('product_images__ul_slide_2_new_pdp');
}


if($(".product_images__ul li").length >= 1){
  $('.product_images__ul_slide_2_new_pdp').slick({
    infinite : true,
    slidesToShow : 3,
    slidesToScroll : 1,
    focusOnSelect : true,
    adaptiveHeight : true,
    //asNavFor: '.product_images__ul_slide_for',
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
}
$('.product_images__ul_slide_3_new_pdp').slick({
  infinite : true,
  slidesToShow : 3,
  slidesToScroll : 1,
  focusOnSelect : true,
  adaptiveHeight : true,
  //   asNavFor: '.product_images__ul_slide_for',

  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1
      }
    }
  ]
});

$('.variant_values label').on('click', function(){
  var data_img = $(this).data('img');
  console.log(data_img);
  $('.product_images__ul li').each(function(){
    var image = $(this).data('img');
    if(data_img == image){
      $(this).trigger('click');
    }
  });
});


$('.product_images__ul').slickLightbox({
  itemSelector        : 'a',
  navigateByKeyboard  : true
});
$('.product__Detils_main_image').slickLightbox({
  itemSelector        : 'a',
  navigateByKeyboard  : true
});
$('.product__Detils_main_image').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  adaptiveHeight: true,
  asNavFor: '.product__Detils_nav_image'
});
$('.product__Detils_nav_image').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  asNavFor: '.product__Detils_main_image',
  dots: false,
  focusOnSelect: true
});
$('.product_gallary_grid').slickLightbox();

$('.compare_pro_ul_').slick({
  infinite        : false,arrows: false,
  slidesToShow    : 3,
  slidesToScroll  : 1,

  responsive: [
    {
      breakpoint: 800,
      settings: {
        slidesToShow: 2,arrows: false,
        slidesToScroll: 1
      }
    }
  ]
});

$('.Engineered__row_ul').slick({
  infinite        : false,arrows: false,
  slidesToShow    : 3,
  slidesToScroll  : 1,

  responsive: [
    {
      breakpoint: 800,
      settings: {
        slidesToShow: 2,arrows: false,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,arrows: false,
        slidesToScroll: 1
      }
    }
  ]
});



//Match title height
function MatchHeight() {
  $('.Engineered__inside').matchHeight();
  ;
//   $('.product_section_grids').matchHeight({});
}



//Functions that run when all HTML is loaded
$(document).ready(function() {
  MatchHeight(); 
});

$( document ).ready(function() {
  var Compatible_count = parseInt($('.Compatible___pro_ul').attr('data-cpro-count'));
  $('.Compatible___pro_ul').slick({
    infinite: false,
    speed: 300,
    slide:'li',
    slidesToShow:  Compatible_count,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 620,
        settings: {
          slidesToShow: 1,arrows: false,
          slidesToScroll: 1
        }
      }
    ]
  });
});


$('.build__product_ul').slick({
  infinite        : false,arrows: false,
  slidesToShow    : 3,
  slidesToScroll  : 1,

  responsive: [
    {
      breakpoint: 400,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});

$('.collection__listing_ul_v2').slick({
  speed: 300,
  slidesToShow: 4,variableWidth: true,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1100,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 749,
      settings: "unslick"
    }
  ]
});

$( document ).ready(function() {
  $('.product_listing_slider_ul').slick({
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 749,
        settings: "unslick"
      }
    ]
  });
  $('.product__options.swatch__images:first-child').click();
});

$(".swatch__images").on('click', function(e) {
  var swatch_image_list = $(this).find('.swatch__image_figure').attr("data-image");
  $(this).parents('.home__product_grid_v2').find('.product_image__grid_v2 .product__figure__v2 img').attr('src', swatch_image_list);
});


if($(window).width() >= 890){
  var header_height = $('.header-wrapper').height();
  $(window).scroll(function() {
    var scroll = $(window).scrollTop();
    //>=, not <=
    if (scroll >= header_height ) {
      //clearHeader, not clearheader - caps H
      $(".Product_sticky_main_div_bottom").addClass("show__sticky_product");
    }
    else{
      $(".Product_sticky_main_div_bottom").removeClass("show__sticky_product");
    }
  });
  
}

if($(window).width() <= 890){
  var header_height = $('.header-wrapper').height();
  $(window).scroll(function() {    
    var scroll = $(window).scrollTop();
    //>=, not <=
    if (scroll >= header_height ) {
      //clearHeader, not clearheader - caps H
      $(".Product_sticky_main_div_mobile").addClass("show__sticky_product");
    }
    else{
      $(".Product_sticky_main_div_mobile").removeClass("show__sticky_product");
    }
  });
}
$(".open__bototm_buy_bar, .close_bottom_buy_bar,.openbtmbtm").on('click', function() {
  $(".Product_sticky_main_div_bottom").toggleClass("show__sticky_product");
});
$('.newcartbtncls').on('click',function(e){
	$('.deafultcart').trigger('click');
});
$('.dropdown_menu_swatch .dropdown_swatch_button').on('click', function(){
   $(this).parent().find('.toggle_swatch').toggleClass('active');
  return false;
});
$(document).on('click', function (e) {
  if ($(e.target).closest(".toggle_swatch").length === 0) {
    $(".toggle_swatch").removeClass('active');
  }
});

$('.toggle_swatch button').on('click', function(){
  var text = $(this).text();
  $('.dropdown_menu_swatch .dropdown_swatch_button').text(text);
  var curId = $(this).parents('li').attr('data-id');
  
  $("#Variants__sticky option").each(function(){
    var optVal = Number($(this).val());
    
    if(curId == optVal){
      $('#Variants__sticky option:selected').removeAttr('selected');
      $(this).attr("selected","selected");
    }
  });
    /*--------RFS-164--------*/
  var currant_data_swatch_title = $(this).attr('data-swatch-title');
 
  $(".product-form__input--color input").each(function(){
  	var inside__each_option = $(this).attr('data-swatch-title');
    
    if(currant_data_swatch_title == inside__each_option){
//       $('#Variants__sticky option:selected').removeAttr('selected');
      $(this).trigger( "click" );
    }
  });
});

$(document).on('click', '.add_to_cart_btn_quantity_template_cls', function(e){
  e.preventDefault();
  var add_to_cart_variant_array = [];

  $('.multiple_purchase_product .quantity__input').each(function(index, value){
    var current = $(value);
    var quantity = parseInt(current.val());
    if(quantity > 0){
      add_to_cart_variant_array.push({
        id: current.data('variant'),
        quantity: quantity,
      });
    }
  });

  if(add_to_cart_variant_array.length > 0) {
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: JSON.stringify({items: add_to_cart_variant_array}),
      dataType: 'json',
      contentType: 'application/json',
      success: function(cart){
        ajaxCart.load();
      
        $('.shoppingcart').trigger('click');
      },
      error: function(XMLHttpRequest, textStatus){
        var data = eval('('+XMLHttpRequest.responseText+')');
        alert(data.description);
        console.log(XMLHttpRequest);
      }
    });
}
});

/*------27-1-22-------*/

// $(".pro__new__accordian__heading, .product__question_grid").on('click', function(e) {
//   $(this).siblings().slideToggle();
//   $(this).toggleClass('accordian__li_opend'); 
//   if($(window).width() <= 620){
//   	$('.product___FEATURES__details_ul_slider').slick('refresh');
//   }
// });
$( window ).on("load", function() {
//   $('.pro__new__accordian__heading').trigger("click");
//   $(".pro__new__accordian_ul .pro__new__accordian__li").eq(0).find('.pro__new__accordian__heading').trigger("click");
// $(".pro__new__accordian_ul .pro__new__accordian__li").eq(1).find('.pro__new__accordian__heading').trigger("click");
});
if($(window).width() <= 1199){
  $('.product___FEATURES__details_ul_slider').slick({
      slidesToShow    : 2,slide:'li',
      slidesToScroll  : 2,arrows: false,
      responsive: [
        {
          breakpoint: 990,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
  });
  
}
$(window).on('resize', function() {
  var viewportWidth = $(window).width();

  if (viewportWidth > 1199) {
    $('.product___FEATURES__details_ul_slider').slick('unslick');
  } else {
  }
});

var sticky_product_height = $('.Product_sticky_main_div').height();
$('.pro__new__accordian__heading').css("top",sticky_product_height + "px");

$(".pro__var_div").on('click', function(e){
  var short_cut_add_tocart__collection_list = $(this).find('.short_cut_add_tocart__collection').attr("data-image");
  var short_cut_add_tocart__collection_list_id = $(this).find('.short_cut_add_tocart__collection').attr("data-id");
  $(this).parents('.product_grid_new_ingrid').find('.product__grid_new_image_image img').attr('src', short_cut_add_tocart__collection_list);
  $(this).parents('.product_grid_new_ingrid').find('.product-form__buttons  .short_cut_add_tocart').attr('data-id', short_cut_add_tocart__collection_list_id);
});

/*--------RFS-318--Start--------*/
$(".country___button").on("click" ,function() {
  $(this).parent().find('.list-container').animate({
      width: "toggle"
    });
  $(this).parent().toggleClass("Country__dropdown_open");
});

if (window.location.href.indexOf("ca.") > -1) {
  $('#main-collection-product-grid .grid__item').each(function(){
    var currant_ul_size = $(this).find(".product__color_option_ul > li").length;

    if(currant_ul_size <= 0){
      $(this).find('.product__color_option_ul').hide();
      //     $(this).find('.coll_new_gr_not__available').show();
      $(this).find('.varaints__button').attr('disabled', 'disabled');
    }
  });
  if ($("body").hasClass("template__product")){
    if ($("div").hasClass("variant_values")){
      var currant_ul_size_label = $(".variant_values.product-form__input > label").length;
      if(currant_ul_size_label <= 0){
        $('.coll_new_gr_not__available').show();
        $('.product-form__buttons .product-form__submit').attr('disabled', 'disabled');
      }
    }
  }
  $('.service-item-new.hide_on_canada, .product__pickup-availabilities').hide();
  $('.block-cart-footer .elg_for_free').hide();
}
/*--------RFS-318--End--------*/
/*-----------RFS 164 start----------*/

$(".product__question_grid").on('click', function(e) {
  $(this).siblings().slideToggle();
  $(this).toggleClass('accordian__li_opend'); 
  if($(window).width() <= 1199){
  	$('.product___FEATURES__details_ul_slider').slick('refresh');
  }
});
$(".pro__new__accordian__heading").on('click', function(e) {
  $(this).siblings().slideToggle();
  $(this).toggleClass('accordian__li_opend'); 
  if($(window).width() <= 1199){
    $('.product___FEATURES__details_ul_slider').slick('refresh');
  }
});

$( document ).ready(function() {
  $(".product__options_grid_bottom_2 .swatch__images, .product__options_grid_bottom_2 a").focus(function(){
    $(this).parents('.home__product_grid_v2').addClass("focus---state");   
  }).blur(function () {
    $(this).parents('.home__product_grid_v2').removeClass("focus---state");  
  });
  $(".main_menu_li a").focus(function(){
    $(this).parent('.main_menu_li').siblings().removeClass("Menu_opened");   
    $(this).parent('.megamenu_enable').addClass("Menu_opened");   
    $(this).siblings('.mega_menu_main_div, .sub_menu_main_div').trigger("click");
  })
//   .blur(function () {
//     $(this).parent('.megamenu_enable').removeClass("Menu_opened");  
//   });
  $(".Product_sticky_main_div .dropdown_swatch_button").focus(function(){
    //     $(this).parents('.Product_sticky_main_div').addClass("show__sticky_product");   
    $('html, body').animate({ scrollTop: '+=300px'}, 500);
  })
});

$( window ).on("load", function() {
//   $('.pro__new__accordian__heading').trigger("click");
  $(".pro__new__accordian_ul .pro__new__accordian__li").eq(0).find('.pro__new__accordian__heading').trigger("click");
$(".pro__new__accordian_ul .pro__new__accordian__li").eq(1).find('.pro__new__accordian__heading').trigger("click");
  $(".pro__new__accordian_ul .pro__new__accordian__li").eq(2).find('.pro__new__accordian__heading').trigger("click");
  $(".pro__new__accordian_ul .pro__new__accordian__li").eq(3).find('.pro__new__accordian__heading').trigger("click");
});
// if($(window).width() <= 1199){
//   $('.product___FEATURES__details_ul_slider').slick({
//     slidesToShow    : 1,slide:'li',
//     slidesToScroll  : 1,arrows: false
//   });
// }

var sticky_product_height = $('.Product_sticky_main_div').height();
$('.pro__new__accordian__heading').css("top",sticky_product_height + "px");

recursive();
function recursive(){
  var optionsLength = $('#smsbump-form-98040').length;
  if(optionsLength > 0){
	$( "#smsbump-form-98040 .cw-modal-dialog .cw-close" ).focus();
  }else{
    setTimeout(function(){
      recursive();
    },300);
  }
}
// $(".country___button").on("click" ,function() {
//   $(this).parent().find('ul').slideToggle();
//   $(this).parent().toggleClass("Country__dropdown_open");
// });
/*-----------RFS 164 End----------*/ 

/* BLG UPDATE */

var parent = $(".random-six-articles");
if(parent){
  var divs = parent.children();
  while (divs.length) {
      parent.append(divs.splice(Math.floor(Math.random() * divs.length), 1)[0]);
  }
}
$(document).ready(function() {
  if($('.blog-sticky').length > 0){
    var stickyTop = $('.blog-sticky').offset().top;
    $(window).scroll(function() {
      var windowTop = $(window).scrollTop();
      if (stickyTop < windowTop) {
        $('.blog-sticky').addClass('fixed-sticky')
      } else {
        $('.blog-sticky').removeClass('fixed-sticky')
      }
    });
  }
  $(window).resize(function(){
      $(".blog-slider").each((i, slider)=>{
        const height = $(slider).find(".article-card__image-wrapper").first().height() / 2;
        $(slider).find('.slick-arrow').each((i, arrow)=>{
          $(arrow).css({top: height});
        })
      })
  });
});
let items = $('.random-six-articles .blog-articles__article.article');
if($('.random-six-articles').hasClass( "randomize-articles" )){
    items.sort(function(){
      return Math.random()-0.5;
  });
}
else{
  items.sort(function(a,b){
    return new Date($(b).data("date")) - new Date($(a).data("date"));
  });
}

$(".random-six-articles").html(items)
$(".random-six-articles .blog-articles__article.article").hide().slice(0, 6).show();
$('.blog-slider').on('init', function(event, slick){
  const height = $(this).find(".article-card__image-wrapper").first().height() / 2;
  $(this).find('.slick-arrow').each((i, arrow)=>{
    $(arrow).css({top: height});
  })
});
$('.blog-slider').slick({
  slidesToShow: 3,
  centerPadding:'30px',
  arrows: true,
  infinite: false,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        centerPadding:'10px',
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1
      }
    }
  ]
});

document.addEventListener("DOMContentLoaded", function() {
  if (window.location.href.includes("?lang")) {
      const countryPickerButton = document.querySelector("country-picker button");
      if (countryPickerButton) {
          countryPickerButton.click();
      }
  }
})

function removeRelNext () {
  const relNext = document.querySelectorAll('link[rel="next"]');
  const relPrev = document.querySelectorAll('link[rel="next"]');
  relNext.forEach((link) => link.remove())
  relPrev.forEach((link) => link.remove())
}

if (document.querySelector('.template__collection')) {
    removeRelNext();
}


// $('.list-toggles').slick({
//   slidesToShow: 5,
//   arrows: true,
//   infinite: false,
//   responsive: [
//     {
//       breakpoint: 889,
//       settings: {
//         slidesToShow: 3,
//         centerPadding:'10px'
//       }
//     },
//     {
//       breakpoint: 470,
//       settings: {
//         slidesToShow: 2
//       }
//     }
//   ]
// });

  document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('.template__search')) {
      let checkMethod = true;
      let checkForFullyLoad = setInterval(() => {
        if(document.querySelectorAll('.boost-sd__product-item').length && checkMethod) {
          checkMethod = false;
          clearInterval(checkForFullyLoad);
          const productElements = document.querySelectorAll('.boost-sd__product-item');
          console.log('productElements', productElements);
          productElements.forEach(product => {
            if (product.getAttribute('data-product-id') === '7306169516171') {
                product.querySelector('.boost-sd__product-label').style.display = 'none';
                product.querySelector('.boost-sd__button').textContent = 'Pre-order';
                product.querySelector('.boost-sd__button').removeAttribute('disabled');
            }
          });
        }
      }, "100");
    }
  }); 

document.addEventListener("DOMContentLoaded", function () {
  const subdomain = window.location.hostname.split('.')[0];

  const languageMap = {
    'de': 'de',
    'at': 'de',
    'dk': 'da'
  };

  const hideSwitcherSubdomains = [
    'hr', 'ee', 'lv', 'nl', 'ro', 'es', 'be', 'cz', 'fi', 'hu',
    'lt', 'pl', 'sk', 'se', 'bg', 'fr', 'it', 'lu', 'pt', 'si'
  ];

  let targetLang = languageMap[subdomain] || 'en';

  const autoSwitchLang = () => {
    if (!sessionStorage.getItem('selectedLang')) {
      if (Weglot.getCurrentLang() !== targetLang) {
        Weglot.switchTo(targetLang);
      }
    }
  };

  const hideLanguageSwitcher = () => {
    const switcher = document.querySelector('.weglot-container');
    if (switcher) {
      switcher.style.display = 'none';
    }
  };

  const replaceGermanFlagWithAustria = () => {
    const weglotListbox = document.querySelector('#weglot-listbox');
    if (weglotListbox) {
      const deLangItems = weglotListbox.querySelectorAll('li[data-l="de"] img.wg-flag');
      deLangItems.forEach(img => {
        img.src = 'https://cdn.weglot.com/flags/rectangle_mat/at.svg';
        img.alt = 'Austria flag';
      });
    }
    const activeDeImg = document.querySelector('.wg-li.de.wgcurrent img.wg-flag');
    if (activeDeImg) {
      activeDeImg.src = 'https://cdn.weglot.com/flags/rectangle_mat/at.svg';
      activeDeImg.alt = 'Austria flag';
    }
  };

  const restrictLanguagesForSubdomain = () => {
    if (hideSwitcherSubdomains.includes(subdomain)) {
      return;
    }

    let allowedLangs = ['en'];

    if (subdomain === 'de' || subdomain === 'at') {
      allowedLangs = ['de', 'en'];
    } else if (subdomain === 'dk') {
      allowedLangs = ['da', 'en'];
    }

    const weglotListbox = document.querySelector('#weglot-listbox');
    if (weglotListbox) {
      const langItems = weglotListbox.querySelectorAll('li[data-l]');
      langItems.forEach(item => {
        const langCode = item.getAttribute('data-l');
        item.style.display = allowedLangs.includes(langCode) ? '' : 'none';
      });

      if (subdomain === 'at') {
        replaceGermanFlagWithAustria();
      }

      const currentLang = Weglot.getCurrentLang();
      if (!allowedLangs.includes(currentLang)) {
        Weglot.switchTo(targetLang);
      }
    }
  };

  if (hideSwitcherSubdomains.includes(subdomain)) {
    const observerHide = new MutationObserver(() => {
      const switcher = document.querySelector('.weglot-container');
      if (switcher) {
        hideLanguageSwitcher();
        observerHide.disconnect();
      }
    });
    observerHide.observe(document.body, { childList: true, subtree: true });

    hideLanguageSwitcher();
    return;
  }

  if (window.Weglot && Weglot.initialized) {
    autoSwitchLang();
    restrictLanguagesForSubdomain();
  }

  document.addEventListener('weglot:init', () => {
    autoSwitchLang();
    restrictLanguagesForSubdomain();
  });

  const observer = new MutationObserver(() => {
    const weglotListbox = document.querySelector('#weglot-listbox');
    if (weglotListbox) {
      weglotListbox.addEventListener('click', (e) => {
        const langItem = e.target.closest('[data-l]');
        if (langItem) {
          sessionStorage.setItem('selectedLang', langItem.getAttribute('data-l'));
        }
      });

      restrictLanguagesForSubdomain();

      const listboxObserver = new MutationObserver(() => {
        if (subdomain === 'at') {
          replaceGermanFlagWithAustria();
        }
      });
      listboxObserver.observe(weglotListbox, { childList: true, subtree: true });

      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});

document.addEventListener('DOMContentLoaded', () => {
  const builderElement = document.getElementById('builder');
  if (!builderElement) return;

  let debounceTimeout;

  const observer = new MutationObserver(() => {
    clearTimeout(debounceTimeout);

    debounceTimeout = setTimeout(() => {
      const dataElement = builderElement.querySelector('[data-camera-controls-version]');
      const canvasElement = builderElement.querySelector('.canvas canvas');
      const dataEngineValue = canvasElement?.getAttribute('data-engine')?.trim();

      if (
        dataElement && dataElement.children.length > 0 &&
        canvasElement && dataEngineValue
      ) {
        observer.disconnect();

        builderElement.classList.add('translated');
        builderElement.style.visibility = 'visible';
        builderElement.style.opacity = '1';
        builderElement.removeAttribute('data-wg-notranslate');

        const currentLang = Weglot.getCurrentLang();

        if (currentLang !== 'en') {
          Weglot.switchTo('en', false);
          Weglot.switchTo(currentLang, false);
        } else {
          Weglot.switchTo(currentLang, false);
        }
      }
    }, 300);
  });


  observer.observe(builderElement, { childList: true, subtree: true });
});

